var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as Long from "long";
import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { selectBalancingResource } from "../../../balancingSelectors/selectBalancingResources";
import { CoopConstants } from "../../../constants/CoopConstants";
import { selectInventoryResourceInfo } from "../../../selectors/selectInventoryInfo";
import { resourcesConfig } from "../../../setup/resourcesConfig";
import { actionInventoryInfoRequestAddResource } from "../../info/inventory/actionInventoryInfo";
import { ResourceWithButton } from "../resource-with-button/ResourceWithButton";
import { Resource } from "../resource/Resource";
var _ResourceBar = function (_a) {
    var _b = _a.className, className = _b === void 0 ? "" : _b, resources = _a.resources, getResourceInfo = _a.getResourceInfo, onButtonClick = _a.onButtonClick;
    var resourcesInfo = resources.map(function (id) {
        return getResourceInfo(id);
    });
    var resourcesRequirements = resourcesInfo.map(function (resource, index) {
        return resourcesConfig[resource.id].canBeBought &&
            resource.id !== CoopConstants.LoyaltyPointsResourceId ? (React.createElement(ResourceWithButton, { key: index, resource: resource, onButtonClick: function () { return onButtonClick(resource.typeId); } })) : (React.createElement(Resource, { key: index, resource: resource }));
    });
    return (React.createElement("div", { className: "flex flex--around flex--aligned flex__full " + className }, resourcesRequirements));
};
var getResourceData = function (state, id) {
    var resourceProto = selectInventoryResourceInfo(state, id);
    var resourceBalancing = selectBalancingResource(id);
    return __assign({}, resourceProto, resourceBalancing, { amount: resourceProto.amount || Long.ZERO });
};
var mapState = function (state) { return ({
    getResourceInfo: function (id) { return getResourceData(state, id); },
}); };
var mapDispatch = function (dispatch) {
    return bindActionCreators({
        onButtonClick: actionInventoryInfoRequestAddResource,
    }, dispatch);
};
export var ResourceBar = connect(mapState, mapDispatch)(_ResourceBar);



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/resource-bar/ResourceBar.tsx
// module id = 200
// module chunks = 3